// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__61Fz8","main-wrapper":"Layout_main-wrapper__zfDNr","main-content":"Layout_main-content__ZLWyh"};